import { render, staticRenderFns } from "./p.vue?vue&type=template&id=12ffd5b6&scoped=true"
import script from "./p.vue?vue&type=script&lang=js"
export * from "./p.vue?vue&type=script&lang=js"
import style0 from "./p.vue?vue&type=style&index=0&id=12ffd5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ffd5b6",
  null
  
)

export default component.exports